import { Cookies } from 'react-cookie';

import { FloorPlansResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getPlanList = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`v1/objects/${slug}/plans/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as FloorPlansResponse;
};
